import { createLinkComponent } from '@stackflow/link';

import type { TypeActivities } from './stackflow';

export const { Link } = createLinkComponent<TypeActivities>();
